import { Component, OnInit } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { RefreshService } from './refresh.service';

@Component({
  selector: 'app-refresh-widget',
  templateUrl: './refresh-widget.component.html',
  styleUrls: ['./refresh-widget.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressBarModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule
  ]
})
export class RefreshWidgetComponent implements OnInit {
  private interval?: number;
  private lastTriggerTime = 0;
  public progressBarValue: number | null = null;
  public refreshIntervalControl = new FormControl("180000");

  constructor(private refreshService: RefreshService) {
    this.handleRefreshIntervalChange(this.refreshIntervalControl.value);
    this.refreshIntervalControl.valueChanges.subscribe((value) => this.handleRefreshIntervalChange(value));
    setInterval(() => this.updateProgressBar(), 250);
  }

  ngOnInit() {
    this.trigger();
  }

  public trigger() {
    this.lastTriggerTime = Date.now();
    this.refreshService.trigger();
  }

  handleRefreshIntervalChange(value: string | null) {
    if (this.interval) {
      clearInterval(this.interval);
    }
    const nInterval = value ? parseInt(value) : undefined;
    if (nInterval && nInterval > 0) {
      const diff = Date.now() - this.lastTriggerTime;
      if (diff < nInterval) {
        this.trigger();
      }
      this.interval = setInterval(() => this.trigger(), nInterval) as unknown as number;
    }
  }

  updateProgressBar() {
    const now = Date.now();
    const diff = now - this.lastTriggerTime;
    const intervalDuration = this.refreshIntervalControl.value ? parseInt(this.refreshIntervalControl.value) : undefined;
    if (!intervalDuration) {
      this.progressBarValue = null;
    } else {
      this.progressBarValue = Math.ceil(100 * diff / intervalDuration);
    }
  }
}
